import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Environment } from './environment.model';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1 ||
  window.navigator.userAgent.indexOf('Edge') > -1;

/**
 * This file will be replaced during prod build through the prebuild.js script.
 * That way, prod setting apply for deployed versions.
 */
export const environment: Environment = {
  production: false,
  azureEndpoint: 'https://staging.api.schenck.one',
  apiBaseUrl: 'https://staging.api.schenck.one/rc/api/v1', // against deployed/cloud backend
  usBaseUrl: 'https://staging.api.schenck.one/user', //  for user settings api
  umBaseUrl: 'https://staging.api.schenck.one/um/v2/rights/RC',
  amBaseUrl: 'https://staging.api.schenck.one/am/v1', // against deployed/cloud backend
  apiVersion: '1.0',
  versionInfo: {
    tag: 'staging',
    hash: '74d598c78c064e05e0e72721b443d2024f82a46c',
    buildtimestamp: '2026-07-13T08:00:51.3901380Z',
    buildVersion: '3.0.0+4381',
  },
  msalConfig: {
    msal: {
      auth: {
        clientId: '5777eabb-b48e-492b-80a3-c8d053d3e6a0',
        knownAuthorities: ['durrgroupb2c.b2clogin.com'],
        authority: 'https://durrgroupb2c.b2clogin.com/durrgroupb2c.onmicrosoft.com/B2C_1A_SIGNIN',
        redirectUri: 'https://staging.reportcenter.schenck.one',
        postLogoutRedirectUri: 'https://staging.reportcenter.schenck.one/postlogout',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    },
    guard: {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          'https://durrgroupb2c.onmicrosoft.com/fe173409-9be8-45ff-a77d-184f3ec74c50/API.All',
        ],
      },
      loginFailedRoute: '/login-failed',
    },
  },
};
